import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import PropTypes from 'prop-types';
// Core components
import List from 'components/core/List';
import ListItem from 'components/core/ListItem';
// Models
import mPermission from 'models/permission';
// Custom
import { permissionsListShape } from 'constants/PropTypesShapes';
import CollapseBoxTemplate from 'components/templates/CollapseBoxTemplate';
import AppIcon from 'components/icons/AppIcon';

const PermissionsList = ({
  product,
  permissionsList,
  profilePermissions,
  withCheckIcon,
  withSelection,
  onTogglePermission,
}) => {
  // Filter permissions from their product, then sort them
  const permissions = mPermission.sortElements(_filter(permissionsList.elements, ['product', product]));

  // Determine the groups visible (from permissions list sent by server)
  const permissionsGroupsVisible = mPermission.filterGroupsFromPermissions(permissions);

  return (
    <div className="row">
      {_map(permissionsGroupsVisible, ({ name, targets }) => (
        <div className="col-12 pt-3 px-0 px-md-3" key={name}>
          <CollapseBoxTemplate
            title={<LocalizedMessage id={`permissionsGroup.${name}`} />}
            titleSize="sm"
            initiallyClosed="true"
          >
            <List>
              {_map(targets, (target) => (
                _map(mPermission.filterFromTarget(permissions, target), (permission) => (
                  <ListItem
                    key={_toString(permission.name)}
                    primaryText={<LocalizedMessage id={`permission.${permission.name}`} />}
                    rightItem={(withCheckIcon && _includes(profilePermissions, permission.name)) ? <AppIcon defaultColor id="check" /> : null}
                    selection={withSelection ? {
                      selected: !!_includes(profilePermissions, permission.name),
                      onSelect: (checked) => onTogglePermission(permission, checked),
                    } : null}
                  />
                ))
              ))}
            </List>
          </CollapseBoxTemplate>
        </div>
      ))}
    </div>
  );
};

PermissionsList.propTypes = {
  product: PropTypes.string.isRequired,
  permissionsList: permissionsListShape.isRequired,
  profilePermissions: PropTypes.arrayOf(PropTypes.string),
  withCheckIcon: PropTypes.bool,
  withSelection: PropTypes.bool,
  onTogglePermission: PropTypes.func,
};

PermissionsList.defaultProps = {
  profilePermissions: [],
  withCheckIcon: false,
  withSelection: false,
  onTogglePermission: null,
};

const mapStateToProps = (state) => ({
  permissionsList: state.permission.list,
});

module.exports = connect(
  mapStateToProps,
  null,
)(PermissionsList);



// WEBPACK FOOTER //
// ./routes/app/routes/profiles/assets/permissions/PermissionsList.js